import milestones from "./milestones";
import openProjects from "./open-projects";
import closedProjects from "./closed-projects";
import manualEntry from "./manual-entry";
import adjustPrevious from "./adjust-previous";
import fixedPriceWorkOrder from './fixed-price-wo';
import approvals from "./approvals";
import finalizeBranch from "./finalize-branch";
import {companyData} from "../../global/change-company";

const _company = companyData.id;
const _month = $('[name="Month"]').val();
const _year = $('[name="Year"]').val();
let _salespersonId = Number($('[name="Salesperson"]').val());
let _isBmOrServiceVp = false;
let _salespersonDropDownList;

export default function (namePage) {
    if (_salespersonId === 0) {
        _salespersonId = Number($('#SalespersonId').val());
    }
    $('js-current-user').text()
    if (namePage === 'sbcommissionsfinalizebranch') {
        _isBmOrServiceVp = true;
        /*Finalize Branch Page*/
        approvals(_company, _month, _year, _salespersonId);
        finalizeBranch(_company, _month, _year, _salespersonId);

        sidebarTotals();

        setSalespersonDropdownList();
        updateSalespersonList();
        return;
    }

    if (namePage === 'sellerbuildercommissions') {
        _isBmOrServiceVp = $('[name=IsBmOrServiceVp]').prop('checked');
        const menuItems = $('.menu-topbar__item');
        const overflow = menuItems.length - 6;
        if (overflow > 0) {
            if (overflow === 1) {
                menuItems.css('font-size', '77%');
            } else {
                const percentReduction = 100 - (17 * overflow);
                menuItems.css('font-size', `${percentReduction}%`);
            }
        }

        $('.menu-topbar__link').click(function () {
            loadTab(this);
        });
        setActiveTab();

        sidebarTotals();

        setSalespersonDropdownList();
        updateSalespersonList();
    }
}

function setActiveTab() {
    const urlHash = window.location.hash || '#OpenProjects';
    setTimeout(function () {
        $(`[href="${urlHash}"]`).click();
    }, 100);
}

function loadTab(ele) {
    const $activeTab = $(ele || '.menu-topbar__link.--active');
    const text = $activeTab.text();

    switch (text) {
        case 'Milestones' : {
            milestones(_company, _month, _year, _salespersonId);
            break;
        }
        case 'Open Projects > $500k' : {
            openProjects(_company, _month, _year, _salespersonId);
            break;
        }
        case 'Closed Projects' : {
            closedProjects(_company, _month, _year, _salespersonId);
            break;
        }
        case 'Manual Entry' : {
            manualEntry(_company, _month, _year, _salespersonId);
            break;
        }
        case 'Adjust Previous' : {
            adjustPrevious(_company, _month, _year, _salespersonId);
            break;
        }
        case 'Fixed Price WO' : {
            fixedPriceWorkOrder(_company, _month, _year, _salespersonId);
            break;
        }
        case 'Approvals' : {
            approvals(_company, _month, _year, _salespersonId);
            break;
        }
        default :
            break;
    }
}

function sidebarTotals() {
    // Calculate Current Commission Totals
    const newProjectsAmount = Number($('.js-new-projects-amount').val()) || 0;
    const projectsUnderAmount = Number($('.js-projects-under-amount').val()) || 0;
    const projectsOverAmount = Number($('.js-projects-over-amount').val()) || 0;
    const manualAmount = Number($('.js-manual-amount').val()) || 0;
    const commissionsTotal = newProjectsAmount + projectsUnderAmount + projectsOverAmount + manualAmount;

    $('.js-commission-total').val(commissionsTotal);
    $('.js-commission-total-text').text(kendo.format('{0:C2}', commissionsTotal));

    // Calculate Completed Current Commission Totals
    const prevGpAmount = Number($('.js-previous-gp-amount').val()) || 0;
    const janAmount = Number($('.js-jan-amount').val()) || 0;
    const febAmount = Number($('.js-feb-amount').val()) || 0;
    const marAmount = Number($('.js-mar-amount').val()) || 0;
    const aprAmount = Number($('.js-apr-amount').val()) || 0;
    const mayAmount = Number($('.js-may-amount').val()) || 0;
    const junAmount = Number($('.js-jun-amount').val()) || 0;
    const julAmount = Number($('.js-jul-amount').val()) || 0;
    const augAmount = Number($('.js-aug-amount').val()) || 0;
    const sepAmount = Number($('.js-sep-amount').val()) || 0;
    const octAmount = Number($('.js-oct-amount').val()) || 0;
    const novAmount = Number($('.js-nov-amount').val()) || 0;
    const decAmount = Number($('.js-dec-amount').val()) || 0;
    const ytdTotal = prevGpAmount + janAmount + febAmount + marAmount + aprAmount + mayAmount + junAmount + julAmount + augAmount + sepAmount + octAmount + novAmount + decAmount;

    $('.js-ytd-total').val(ytdTotal);
    $('.js-ytd-total-text').text(kendo.format('{0:C2}', ytdTotal));

}

function updateSalespersonList() {
    const $monthDropdown = $('#MonthDisplay');

    if ($monthDropdown) {
        $monthDropdown.change(function () {
            if (_salespersonDropDownList) {
                _salespersonDropDownList.dataSource.read();
            }
        })
    }
}

function setSalespersonDropdownList() {
    _salespersonDropDownList = $('.js-salesperson-list').kendoDropDownList({
        dataTextField: "Name",
        dataValueField: "Value",
        dataSource: {
            transport: {
                read: {
                    url: '/Finance/SellerBuilderCommissions/GetSalespersonsList',
                },
                parameterMap: function (data, type) {
                    let rs = {};
                    if (type === 'read') {
                        const monthYear = $('#MonthDisplay').data('kendoDropDownList').value().split('/');
                        rs['company'] = _company;
                        rs['month'] = monthYear[0];
                        rs['year'] = monthYear[1];
                        rs['isBmOrServiceVp'] = _isBmOrServiceVp;
                        return rs;
                    }
                }
            }
        }
    }).data('kendoDropDownList');

    if (_salespersonDropDownList) {
        _salespersonDropDownList.value(_salespersonId);
        setTimeout(function () {
            $('.js-current-user').text(_salespersonDropDownList.text()).parent().show()
        }, 250)

    }
}
